/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss';
import styles from './sectiongroupv2_styles';


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION GROUP V2 ~~~~~~~~~~ ========== */
const SectionGroupV2 = (props) => {
    const {
        title,
        description,
        indented,
        direction,
        children,
        disabled,
        rowGap
    } = props
    return (
      <div className={`sectiongroupv2 ${props.classes.sectiongroupv2} ${props.klass} ${props.disabled ? 'disabled' : ''}`}>
        <div className={'header'}>
          <h3 className='title'>{title}</h3>
          { description && <p className='description'>{description}</p>}
        </div>
        <div className={`content direction-${direction || 'row'} indented-${!!indented}`}>{children}</div>
      </div>
    )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionGroupV2);
